
import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer2 from './Footer2';
import './Gallery.css';

const Gallery = () => {
    const [selectedImg, setSelectedImg] = useState(null);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const artwork = [
        { id: 1, src: '/assets/img/Gallery/G1.jpeg' },
        { id: 2, src: '/assets/img/Gallery/G2.JPG' },
        { id: 3, src: '/assets/img/Gallery/G3.JPG' },
        { id: 4, src: '/assets/img/Gallery/G4.jpg' },
        { id: 5, src: '/assets/img/Gallery/G5.jpg' },
        { id: 6, src: '/assets/img/Gallery/G6.jpg' },
        { id: 7, src: '/assets/img/Gallery/G7.jpeg' },
        { id: 8, src: '/assets/img/Gallery/G8.JPG' },
        { id: 9, src: '/assets/img/Gallery/G9.JPG' },
        { id: 10, src: '/assets/img/Gallery/G10.JPG' },
        { id: 11, src: '/assets/img/Gallery/G11.JPG' },
        { id: 12, src: '/assets/img/Gallery/G12.jpg' },
        { id: 13, src: '/assets/img/Gallery/G13.JPG' },
        { id: 14, src: '/assets/img/Gallery/G14.JPG' },
        { id: 15, src: '/assets/img/Gallery/G15.JPG' },
        { id: 16, src: '/assets/img/Gallery/G16.jpg' },
        { id: 17, src: '/assets/img/Gallery/G17.jpg' },
        { id: 18, src: '/assets/img/Gallery/G18.JPG' },
        { id: 19, src: '/assets/img/Gallery/G19.JPG' },
        { id: 20, src: '/assets/img/Gallery/G20.JPG' },
        { id: 21, src: '/assets/img/Gallery/G21.JPG' },
        { id: 22, src: '/assets/img/Gallery/G22.jpg' },
        { id: 23, src: '/assets/img/Gallery/G23.JPG' },
        { id: 24, src: '/assets/img/Gallery/G24.png' },
        { id: 25, src: '/assets/img/Gallery/G25.JPG' },
        { id: 26, src: '/assets/img/Gallery/G26.jpg' },
        { id: 27, src: '/assets/img/Gallery/G27.JPG' },
        { id: 28, src: '/assets/img/Gallery/G28.JPG' },
        { id: 29, src: '/assets/img/Gallery/G29.JPG' },
        { id: 30, src: '/assets/img/Gallery/G30.JPG' },
        { id: 31, src: '/assets/img/Gallery/G31.JPG' },
        { id: 32, src: '/assets/img/Gallery/G32.JPG' },
        { id: 33, src: '/assets/img/Gallery/G33.JPG' },

    ];


    return (
        <div className="gallery-page-wrapper">
            <Header />

           <div className={`gallery-content-area ${!showAll ? 'is-limited' : ''}`}>
    <div className="masonry-grid">
        {artwork.map((item, i) => (
            <div
                key={item.id}
                className="masonry-item"
                onClick={() => setSelectedImg(item.src)}
            >
                <img
                    src={item.src}
                    alt={`Artwork ${item.id}`}
                    loading="lazy"
                />
            </div>
        ))}
    </div>

    {!showAll && (
        <div className="see-more-overlay">
            <button className="see-more-btn" onClick={() => setShowAll(true)}>
                VIEW MORE
            </button>
        </div>
    )}
</div>

            {/* Lightbox Modal */}
            {selectedImg && (
                <div className="lightbox-overlay" onClick={() => setSelectedImg(null)}>
                    <span className="close-btn">&times;</span>
                    <div className="lightbox-container">
                        <img src={selectedImg} alt="Enlarged Artwork" className="lightbox-img" />
                    </div>
                </div>
            )}
            
            <Footer2 />
        </div>
    );
};

export default Gallery;